export default __webpack_public_path__ + "static/media/C_ic.24505987.svg";